import toast from "react-hot-toast";
import userService from "../_services/user.service";
import { imageConverter } from "../_helper/imageConverter";
import { parseJson } from "../_helper";
import { v4 as uuidv4 } from 'uuid';
import { IoClose } from "react-icons/io5";

/**get ticket questions **/
export const getTicketQuestions = async (ticketId, questionData = null) => {
    let questionList = {};
    try {
        /** get ticket questions by ticket id **/
        let data = null; 

        if (questionData) {
          data = questionData;  
        } else {
          data = await userService.getTicketQuestions(ticketId);
        }
        
        /** parse ticket questions **/
        let questionsList = parseJson(data?.data?.questionaire) ?? [];


        questionsList?.map((questionDetail => {
            let qt = questionDetail?.Question?.question;
            let qtId=questionDetail?.Question?.question_id;

            /** if no question then find question in follow **/
            if(!qt){
                let qstDetail=questionDetail?.Response?.FollowUp?.Question;
                qt=qstDetail?.question;
                qtId=qstDetail?.question_id;
            }

            let res = questionDetail?.Response?.[0]?.response;
            if(!res){
              res=  questionDetail?.Response?.["0"]?.response;
              if(!res){
                res=questionDetail?.Response?.FollowUp?.Response?.[0]?.response;
              }
            }
            if (/other/.test(res?.toLowerCase())) {
                res = questionDetail?.Response?.FollowUp?.Response?.["0"]?.response;
            }
            
            if (/i do not agree/i.test(res?.toLowerCase())) {
                res="show alert";
            }

            if(qtId){
               questionList[qtId]={
                q:qt,
                res
              };
            }

        }));
    } catch (error) {

    }
    return questionList;
}

/**process ticket details */
export const processTicketDetails = async (eventData, design, orderDetail, userEmail, showPartial = false, isPreview = false, isScan = false) => {
    try {
      let eventbadgeDesign=design;
      let height=609;
      
        let elements=parseJson(eventbadgeDesign?.elements);
        if(elements?.length==0){
          eventbadgeDesign=defaultBadgeDetails();
          elements=parseJson(eventbadgeDesign?.elements);
        }
        let canvasSize = parseJson(eventbadgeDesign?.canvas_size);
        canvasSize={
          ...canvasSize,
          height:((canvasSize.height>height && !isPreview)?height:canvasSize.height)*2,
          width:canvasSize.width*2,
        }
        let selectedFields=parseJson(eventbadgeDesign?.selectedFields);
        let alertInfo=selectedFields?.alertInfo??{};
        let fontFamily = eventbadgeDesign?.selectedFont;
        let hasTicket=orderDetail?.ticketId;
        let name=orderDetail?.firstName??orderDetail?.name??"";
        let last_name=orderDetail?.lastName??"";
        let answerList=[];
        let questionList={};
        let hasAlert=false;
        let filterElements = {
            eventId: eventData?.eventId,
            orderId: orderDetail?.orderId,
            ticketId:orderDetail?.ticketId,
            title: eventData?.event_topic,
            company:eventData?.organization_name,
            email:orderDetail?.email??"",
            phone:orderDetail?.phone??"",
            badge_orientation: selectedFields?.selectedFields?.orientation,
            name: name,
            last_name,
            full_name: `${name} ${last_name}`,
            attendee_name: (orderDetail?.name && orderDetail?.name !== "") ? orderDetail?.name : "-",
            ticket_type:orderDetail?.ticket_type_name,
            state:eventData?.state,
            city:eventData?.city,
            country:eventData?.country,
            fontFamily
        }
        if(hasTicket){
            try {
            questionList=await getTicketQuestions(hasTicket);
            for(let qtn in alertInfo){
              if(questionList?.[qtn]||filterElements?.[qtn]){
                let res=questionList?.[qtn]?.res??filterElements?.[qtn]??"";
               if(!hasAlert){
                 let error=  processAlertDetails(res,{...alertInfo[qtn],alertColor:alertInfo?.alertColor,},showPartial);
                 if(error){
                   hasAlert=error;
                  }
                }
              }
            }

            } catch (error) {
              
            }
        }
        let page1=[];
        let page2=[];
        let hasElement1=false;
        let hasElement2=false;
        let alertResponse=null;
        height*=2;
        elements?.map((el)=>{
          el.x*=2;
          el.y*=2;
          el.height*=2;
          el.width*=2;
          el.fontSize*=2;
        if(el?.isQuestion){
            let key=el?.key;
            let content=questionList[key]?.res??"";
           
            // if(content=="show alert"){
            //     hasAlert=true;
            // }
          content = (/^N\/A$|^NA$|^Not Applicable$/i.test(content.trim())) ? "" : content;
          el.content=content;
        }
        
        else if(el.isLocation){
            let content="";
            let location=el?.location??{};
            if(location?.city)content+=filterElements?.city+" ";
            if(location?.state)content+=filterElements?.state;
            if((location?.state||location?.city)&&location?.country){
                content+=","+filterElements?.country;
            }else if(location?.country){
                content+=filterElements?.country;
            }
            el.content=content;
        }
        else if (el.type === 'qrcode') {
            el.content = JSON.stringify({
                id: filterElements?.ticketId || filterElements?.orderId,
                source: 1
            });
        }
        else if(el.type!='icon'&&el.key!='qr' && !el.isCustomText){
          el.content=filterElements[el?.key]??'';
        }
        if(el?.y>height && !isPreview){
          if(el.content&&el.content!=''||el.key=='qr'){
            hasElement2=true;
            page2.push({
              ...el,
              y:Math.max(10,el.y-height)
            })
          }
        }else{
          if(el.content&&el.content!=''||el.key=='qr'){
            hasElement1=true;
            page1.push(el);
          }
        }
          if(alertInfo?.[el.key]&&!hasAlert){
            let content=filterElements[el?.key]??el.content;
              let error=  processAlertDetails(content,{...alertInfo[el.key],alertColor:alertInfo?.alertColor,},showPartial);
              if(error&&!hasAlert){
                hasAlert=error
              }
          }
        })
      
       if(canvasSize?.height>height && !isPreview){
        canvasSize.height=height;
       }

       let badgeLog={
        first_name:orderDetail?.firstName,
        last_name:orderDetail?.lastName,
        email:userEmail??orderDetail?.email,
        event_id:eventData?.eventId,
        badge_design_id:eventbadgeDesign?.id,
        ticket_id:hasTicket??orderDetail?.orderId
      }
      if(!hasAlert){
        page1=page1.filter(e=>e.type!='icon');
        page2=page2.filter(e=>e.type!='icon');
      }
       return {
        showAlert:hasAlert,
        filterElements,
        page1,
        page2,
        hasElement1,
        hasElement2,
        canvasSize,
        status:true,
        badgeLog
       }
    } catch (error) {
        toast.error(error?.response?.data?.message??"Unable to print ticket",{
          duration:1000
        });
        return {status:false};
    }
}

/**process alert details */
export const processAlertDetails = (response = "", alertInfo = {},showPartial=false) => {
  const color = alertInfo?.alertColor || "#000";
  const expectedRaw = alertInfo?.triggerResponses || "";
  const alertMessage = alertInfo?.alertMessage || "Alert triggered";
  const condition = alertInfo?.condition;

  if (!condition) return;

  const normalizedResponse = response.toLowerCase();
  const expectedValues = expectedRaw
    .split(",")
    .map((v) => v.trim().toLowerCase())
    .filter((v) => v);

  let shouldTrigger = false;

  switch (condition) {
    case "Equals":
      shouldTrigger = expectedValues.some(
        (val) => normalizedResponse === val
      );
      break;

    case "Not Equals":
      shouldTrigger = expectedValues.every(
        (val) => normalizedResponse !== val
      );
      break;

    case "Includes":
      shouldTrigger = expectedValues.some((val) =>
        normalizedResponse.includes(val)
      );
      break;

    case "Not Includes":
      shouldTrigger = expectedValues.every(
        (val) => !normalizedResponse.includes(val)
      );
      break;

    default:
      shouldTrigger = false;
  }

  if (shouldTrigger) {
   if(showPartial==false) showCustomToast(alertMessage,color)
  return alertInfo;
}
return false;
};

/**show custom toast */
const showCustomToast = (alertMessage, color = "#333") => {
  toast.custom((t) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        padding: "12px 16px",
        borderRadius: "8px",
        border: `1px solid ${color}`,
        backgroundColor: "#fff",
        color,
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        minWidth: "300px",
      }}
      role="alert"
    >
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span style={{ fontSize: "14px" }}>{alertMessage}</span>
      </div>

      {/* Close Button */}
      <button
        onClick={() => toast.dismiss(t.id)}
        style={{
          background: "transparent",
          border: "none",
          color,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
        }}
        aria-label="Close"
      >
        <IoClose style={{fill:color}} size={16} />
      </button>
    </div>
  ), {
    position: "top-right",
    duration: 4000,
  });
};

export const printBadgeDetails=async(page,hasElement,filterElements,canvasSize,defaultPrinter,alertInfo,backgroundUrl = null)=>{
    try {
      if(page.length&&hasElement){
      return  await handlePrint({ elements: page, filterElements, canvasSize,defaultPrinter ,alertInfo, backgroundUrl });
      }
      return false;
    } catch (error) {
      console.log(error)
      return false;
    }
}

/**handle print */
export const handlePrint = async ({ elements, filterElements, canvasSize,defaultPrinter, backgroundUrl = null }) => {
    try {
        // Generate the badge image (with optional background)
        let { dataUrl,width,height,rawUrl } = await generateBadgeImage(elements, filterElements, canvasSize, backgroundUrl);
        if (!dataUrl) return null;


        if (process.env.REACT_APP_ENV_MODE == "dev") {
            downloadImageUrl(dataUrl);
            return true;
        }

        // Send the generated image directly to the printer
        const printResult = await printFromImageUrl(dataUrl, {
          ...canvasSize,
        badge_orientation:filterElements?.badge_orientation,
        }, defaultPrinter);
        if (printResult) return { dataUrl: rawUrl, width, height };
        return false;
    } catch (error) {
        toast.error(error?.response?.data?.message ?? "Unable to print badge", {
            duration: 1000
        });
        return null;
    }
};

/**
 * generateBadgeImage
 * Renders badge elements to a canvas and returns image URLs.
 */
export const generateBadgeImage = async (elements, filterElements, canvasSize, backgroundUrl = null) => {
    try {
        if (!elements || !elements.length) return null;
        const result = await imageConverter({ elements, filterElements, canvasSize, backgroundUrl });
        if (!result?.dataUrl) {
            toast.error("Unable to generate badge image", { duration: 1000 });
            return null;
        }
        return result; // { dataUrl, rawUrl, width, height }
    } catch (error) {
        console.error("generateBadgeImage error:", error);
        return null;
    }
};

/**
 * previewBadge
 * Generates a badge preview image with an optional background URL.
 */
export const previewBadge = async (page, hasElement, filterElements, canvasSize, backgroundUrl = null) => {
    if (!page.length || !hasElement) return null;
    const result = await generateBadgeImage(page, filterElements, canvasSize, backgroundUrl);
    return result ?? null;
};

/**
 * printFromImageUrl
 * Takes an already-generated badge image dataUrl and sends it directly to the printer.
 */
export const printFromImageUrl = async (dataUrl, canvasSize, defaultPrinter) => {
    try {
        if (!dataUrl) {
            toast.error("No badge image provided for printing.",{
          duration:1000
        });
            return false;
        }
        
        if (process.env.REACT_APP_ENV_MODE == "dev"){
          downloadImageUrl(dataUrl);
          return true;
        }
       
        const blob = await (await fetch(dataUrl)).blob();
        const file = new File([blob], "image.png", { type: "image/png" });
        let form=new FormData();
        form.append("image",file);
        form.append("height",Math.round(canvasSize?.height));
        form.append("width",Math.round(canvasSize.width));
        if(canvasSize?.labelInfo){
          form.append("x_axis",canvasSize?.labelInfo.width);
          form.append("y_axis",canvasSize?.labelInfo.height);
          form.append("dpi",canvasSize?.labelInfo.dpi);
        }
        if (canvasSize.badge_orientation) {
          form.append("badge_orientation",canvasSize.badge_orientation);
        }
        let data = await userService.getZlpImage(form);
        if (data.success) {
            const zplImage = data.data;
            console.log("zplImage",zplImage)
            const zplBlob = new Blob([zplImage], { type: "text/plain" });
            const zplFile = new File([zplBlob], "label.zpl", { type: "text/plain" });
          let  result= await handlePrintBadgeZpl(defaultPrinter?.ip?zplImage:zplFile,defaultPrinter);
            return result;
        }
        return null;
    } catch (error) {
        toast.error(error?.response?.data?.message ?? "Unable to print badge",{
          duration:1000
        });
        return null;
    }
};

/**
 * handlePrintAndLog
 * Centralized helper to print a badge and then create the badge print log.
 */
export const handlePrintAndLog = async ({
    page1, hasElement1, page2, hasElement2,
    filterElements, canvasSize, defaultPrinter,
    badgeLog, connection_id
}) => {
    try {
        // 1. Print page 1
        let data1 = await printBadgeDetails(page1, hasElement1, filterElements, canvasSize, defaultPrinter);
        let data2 =  await printBadgeDetails(page2, hasElement2, filterElements, canvasSize, defaultPrinter);

        if (!data1 && !data2) return null;

        if(!data1 && data2){
          data1 = data2;
        }

        // 3. Create Badge Log
        const { dataUrl, ...rest } = data1;
        const detailsObj = {
            ...badgeLog,
            ...rest,
            data_url1: dataUrl,
            data_url2: data2?.dataUrl,
            connection_id
        };
        try {
          await userService.createBadgePrintLog(detailsObj);
        } catch (error) {
          console.log("Unable to add badge log", error)
        }
        return detailsObj;
    } catch (error) {
        console.error("handlePrintAndLog error:", error);
        return null;
    }
};





// download image url
export const downloadImageUrl = (dataUrl) => {
  if (!dataUrl) {
     return;
  }
  try {
      const link = document.createElement("a");
      link.download = `badge-${Date.now()}.png`;
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
  } catch (error) {
    console.log("Unable to download", error);
  }
}

/**handle print badge zpl */
export const handlePrintBadgeZpl = async (file,defaultPrinter) => {
    if (!file) {
        toast.error("No badge file available for printing.",{
          duration:1000
        });
        return;
    }
    const formData = new FormData();
    const deviceSerialNumber =defaultPrinter?.serial_number?? process.env.REACT_APP_ZEBRA_DEVICE_SERIAL_NO ?? "D9N224300409";
    formData.append("sn", deviceSerialNumber); // Replace with actual serial number
    formData.append("zpl_file", file);
        try {
        let account_number=defaultPrinter?.account_number;
        if(!account_number){
            const tenantId = await userService.fetchTenantId();
            account_number=tenantId?.[0]?.AccountNumber
        }
        if (account_number) {
            const response = await userService.sendZPLFileToPrint(
                formData,
                account_number
            );
            toast.success("Badge sent to printer successfully!",{
             duration:1000
            });
            return response;
            // setQuery("");
        }
        else if(defaultPrinter?.ip){
            const obj={
                zpl:file,
                printer_ip:defaultPrinter?.ip
            }
          let result=  await userService.printLocal(obj);
            toast.success("Badge sent to printer successfully!",{
          duration:1000
        });
            return result;

        }
        else {
            toast.error(
                "Failed to print badge. Please check the printer connection."
                ,{
          duration:1000
        }
            );
            return false;
        }
    } catch (error) {
        let message = "Failed to print badge. Please check the printer connection.";
        if (error.response) {
            const status = error.response.status;
            const errorData = error.response.data || {};
            const apiMessage = errorData.Message?.toLowerCase?.() || "";

            switch (status) {
                case 400:
                    message = "Bad request. Please check the data you're sending.";
                    break;
                case 401:
                    message = "Unauthorized. Please log in again.";
                    break;
                case 403:
                    if (apiMessage.includes("monetization")) {
                        message = "Access denied due to subscription issues. Please check your plan.";
                    } else {
                        message = "Forbidden. You don’t have permission to print.";
                    }
                    break;
                case 404:
                    message = "Printer not found. Please check your configuration or access rights.";
                    break;
                case 429:
                    message = "Quota exceeded. You have reached your daily API limit.";
                    break;
                case 500:
                    message = "Server error. Please try again later.";
                    break;
                default:
                    message = `Error ${status}: ${errorData.Message || "Unexpected error"}`;
                    break;
            }
        }
        else if (error.request) {
            message = "No response from server. Please check your internet connection.";
        } 
        
        toast.error(message??
            "Failed to print badge. Please check the printer connection."
            ,{
             duration:1000
            }
        );
        return false;
    }
};

/**default badge details */
export const defaultBadgeDetails =  () => {
    let elements = generateElements();
    return {
        canvas_size: {
            height: 609,
            width: 406,
        },
        elements
    }
}

/**generate elements */
const generateElements = () => {
    const requiredFields = [
        { label: "First Name", x: 41, y: 21, key: "name" },
    ];

  return   requiredFields.map(({ label, x, y, key }) => {
    return {
      id: uuidv4(),
      type: "text",
      content: label,
      key: key,
      x,
      y,
      width: 280,
      height: 30,
      fontSize: 16,
      fontFamily: 'Poppins',
      textAlign: 'left',
      color: '#000000',
      fontWeight: 'normal',
      fontStyle: 'normal'
    }
        
    });
}